import { api } from '@/lib/api-client'
import type {
  AdminPromo,
  MessageResponse,
  PageResponse,
  PromoCreateRequest,
  PromoFilters,
  PromoUpdateRequest,
} from '@/types/api'

export function fetchPromoCodes(filters: PromoFilters): Promise<PageResponse<AdminPromo>> {
  return api.get<PageResponse<AdminPromo>>('/api/admin/promo', { query: { ...filters } })
}

export function fetchPromoCode(id: number): Promise<AdminPromo> {
  return api.get<AdminPromo>(`/api/admin/promo/${id}`)
}

export function createPromoCode(payload: PromoCreateRequest): Promise<MessageResponse> {
  return api.post<MessageResponse>('/api/admin/promo/add', payload)
}

/** Also carries the active flag, which is how a promo is enabled or disabled. */
export function updatePromoCode(payload: PromoUpdateRequest): Promise<MessageResponse> {
  return api.post<MessageResponse>('/api/admin/promo/edit', payload)
}
